import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Events',
		url: '/events',
		icon: 'calendar',
	}
];

export default class Events extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-event" onClick={this.toggle('modalEvent')} size="sm" color="primary">
						<i className="fa fa-calendar"/>&nbsp;&nbsp;Add Event
					</Button>
				</Framework.Components.PageBar>

				<Collections.Events
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					name="Event"
					object={Objects.Event}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					toggle={this.state['modalEvent']}
					reportClose={this.reportClose('modalEvent')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}

